import { useState, useCallback } from "react";
import {
  getInitialRegion,
  persistRegion,
  VALID_REGIONS,
} from "../utils/region";

// Region state with localStorage persistence.
// Returns [region, setRegion]. setRegion persists the manual choice.
export function useRegion() {
  const [region, setRegionState] = useState(getInitialRegion);

  const setRegion = useCallback((next) => {
    if (!VALID_REGIONS.includes(next)) return;
    setRegionState(next);
    persistRegion(next);
  }, []);

  return [region, setRegion];
}

export default useRegion;
